import React, {useState, useEffect} from 'react';
import {Modal} from 'antd';
import SmallLogo from '../../assets/images/simple-logo.svg';
import GlobalApi from '../../services/Global';
import {storage} from '../../services/config/storage';
import {useDispatch, useSelector} from 'react-redux';
import {
    logoutApp,
    setActiveModal,
    setHelperPage,
} from '../../store/global/actions';
import {MODALS} from 'utils/constants';

const DisclaimerModal = (props) => {
    const [isUSInvestor, setUSInvestor] = useState(false);
    const [isHKInvestor, setHKInvestor] = useState(false);
    const [loading, setLoading] = useState(false);
    const terms = null;
    const dispatch = useDispatch();
    const {isFreeUser, activeModal} = useSelector(({global}) => global);

    //date comparisson function to check 23rd of october 2023
    const isOctober = () => {
        let currentDate = new Date().getDate();
        let currentMonth = new Date().getMonth() + 1;
        let currentYear = new Date().getFullYear();

        if (currentDate < 23 && currentMonth === 10 && currentYear == 2023) {
            return true;
        } else {
            return false;
        }
    };

    const onAccept = async () => {
        //const terms = {termAccepted: 1, usTermAccepted: 0};
        let terms = {termAccepted: 1, usTermAccepted: 0, hkTermAccepted: 0};
        const userCountry = storage.fetch.userDetails()?.country;
        if (isUSInvestor) {
            terms.usTermAccepted = 1;
            terms.termAccepted = 0;
            terms.hkTermAccepted = 0;
        }
        if (userCountry === 'Hong Kong') {
            terms.usTermAccepted = 0;
            terms.termAccepted = 0;
            terms.hkTermAccepted = 1;
        }
        // if (isUSInvestor) {
        //     terms.usTermAccepted = 1;
        //     terms.termAccepted = 0;
        // }
        setLoading(true);
        let payload = [
            {
                propertyKey: 'usTermAccepted',
                propertyValue: terms.usTermAccepted,
            },
            {
                propertyKey: 'termAccepted',
                propertyValue: terms.termAccepted,
            },
            {
                propertyKey: 'hkTermAccepted',
                propertyValue: terms.hkTermAccepted,
            },
        ];
        if (!isFreeUser) await GlobalApi.updateUserProps(payload);
        localStorage.removeItem('justLoggedIn');
        dispatch(setActiveModal(null));
        setLoading(false);
        if (!localStorage.getItem('LandingHelperViewed')) {
            dispatch(setHelperPage(true));
            localStorage.setItem('LandingHelperViewed', true);
        }

        //fetching lpcDate data from localstorage
        const lpcDate = storage.fetch.userDetails()?.lpcDate;
        const showReminder = isOctober();

        //if user is not freeUser and lpcDate equal null execute below
        if (!isFreeUser && lpcDate === null) {
            dispatch(setActiveModal(MODALS.PASSWORD_REMAINDER));
        }
    };

    const onDecline = () => {
        localStorage.removeItem('justLoggedIn');
        dispatch(logoutApp());
    };

    useEffect(() => {
        if (!activeModal) {
            const user = storage.fetch.userDetails();
            // const {termAccepted, usTermAccepted} = user?.userProps ?? {};
            const {termAccepted, usTermAccepted, hkTermAccepted} =
                user?.userProps ?? {};
            const justLoggedIn = localStorage.getItem('justLoggedIn');

            if (
                justLoggedIn === 'true' ||
                (termAccepted === '0' &&
                    usTermAccepted === '0' &&
                    hkTermAccepted === '0')
            ) {
                dispatch(setActiveModal(MODALS.DISCLAIMER));
            }
        }

        const userCountry = storage.fetch.userDetails()?.country;
        if (userCountry === 'Hong Kong') {
            setHKInvestor(true);
        } else if (userCountry === 'US') {
            setUSInvestor(true);
        }
    }, [activeModal, dispatch]);

    const US_terms = () => (
        <p>
            The information set out in this platform (“Information”) and
            functions of the platform (such as the chat options) you are about
            to access is restricted to and for the use of Major Institutional
            Investors (“MII”) only as defined under Rule 15 a-6 under the U.S.
            Securities Exchange Act of 1934. Your access to the Information and
            functions of this platform is based on information you have provided
            us that you are an authorized representative of an entity that falls
            within this category, and by your continued access of this platform
            you make an ongoing representation that you are an authorized
            representative of an MII.
            <br />
            <br />
            This Information is not an offer to sell or the solicitation of an
            offer to buy any security in any jurisdiction (including but not
            limited to the United States of America) where such an offer or
            solicitation would be contrary to law or regulation.This Information
            is published for general circulation only and does not have regard
            to your specific investment objectives, financial situation. You
            should always seek advice from an independent financial adviser
            and/or consider carefully regarding the suitability of the
            investment product (taking into account your specific investment
            objectives, financial situation and particular needs) before making
            any investment or transaction in reliance on the Information.
            <br />
        </p>
    );

    const non_US_terms = () => (
        <p>
            {terms === '0'
                ? 'I confirm that I am participating in this trial usage of the Insights Direct application in order to provide feedback to DBS on the usefulness of the features and information presented.'
                : 'The information set out in this platform ("Information") is not directed to, or intended for distribution to or use by, any person or entity that is a citizen or resident of or located in any locality, state, country, or other jurisdiction (including but not limited to citizens or residents of the United States of America) where such distribution, publication, availability or use would be contrary to law or regulation.'}
            <br />
            <br />
            {terms === '0'
                ? 'By having access to the trial beta version of Insights Direct, I understand that I should not be relying solely on the information provided on the platform for my investment decisions as Insights Direct is still undergoing further development, even though every effort has been made to verify and ensure that the information found in Insights Direct is accurate and up-to-date.'
                : 'This Information is not an offer to sell or the solicitation of an offer to buy any security in any jurisdiction (including but not limited to the United States of America) where such an offer or solicitation would be contrary to law or regulation, or which would subject DBS Group to any registration requirement within such jurisdiction or country, and should not be viewed as such. Without prejudice to the generality of the foregoing, the information, services, or products described or appearing in this Information are not specifically intended for or specifically targeted at the public in any specific jurisdiction.'}
            {/* <br /> */}
            {/* <br /> */}
            {terms === '0'
                ? 'I also understand that I shall not share the analyses, design and methodologies used in the Insights Direct application with other colleagues or clients without consent from DBS, as they constitute the intellectual property of DBS.'
                : 'This Information is not and shall not be construed as investment advice. This Information is published for general circulation only and does not have regard to your specific investment objectives, financial situation. You should always seek advice from an independent financial adviser and/or consider carefully regarding the suitability of the investment product (taking into account your specific investment objectives, financial situation and particular needs) before making any investment or transaction in reliance on the Information. DBS Group does not assume or undertake any duty to advise any person or investor, and accepts no liability whatsoever for any direct, indirect or consequential loss arising from or in connection with any use or reliance on this Information or anything contained in it. Consent to this disclaimer will be treated as a reverse inquiry by the client to access Group Research (and Economics & Macro Strategy) publications and views, without active solicitation or marketing by the team.'}
            <br />
            {/* <br /> */}
            {terms === '0'
                ? [
                      'I will not hold DBS liable for any loss suffered as a result of using the Insights Direct application',
                      <br />,
                  ]
                : null}
        </p>
    );

    const HK_Disclaimer_Text = () => (
        <>
            This disclaimer is only for Hong Kong based investors.&nbsp;If you
            are a US based investor{' '}
            <span
                style={{color: '#1890ff', cursor: 'pointer'}}
                onClick={() => {
                    setUSInvestor(true);
                    setHKInvestor(false);
                }}
                data-testid="HK_Disclaimer_Text-1"
            >
                click here.
            </span>
            &nbsp;If you are from anywhere else{' '}
            <span
                style={{color: '#1890ff', cursor: 'pointer'}}
                onClick={() => {
                    setUSInvestor(false);
                    setHKInvestor(false);
                }}
                data-testid="HK_Disclaimer_Text-2"
            >
                click here.
            </span>
        </>
    );

    const US_Disclaimer_Text = () => (
        <>
            This disclaimer is only for US based investors. &nbsp;If you are a
            Hong Kong based Investor{' '}
            <span
                style={{color: '#1890ff', cursor: 'pointer'}}
                onClick={() => {
                    setUSInvestor(false);
                    setHKInvestor(true);
                }}
            >
                click here.
            </span>
            &nbsp;If you are from anywhere else{' '}
            <span
                style={{color: '#1890ff', cursor: 'pointer'}}
                onClick={() => {
                    setUSInvestor(false);
                    setHKInvestor(false);
                }}
            >
                click here.
            </span>
        </>
    );

    const All_Disclaimer_Text = () => (
        <>
            This disclaimer is only for non-US and non-Hong Kong based
            investors. &nbsp;If you are a Hong Kong based Investor{' '}
            <span
                style={{color: '#1890ff', cursor: 'pointer'}}
                onClick={() => {
                    setUSInvestor(false);
                    setHKInvestor(true);
                }}
                data-testid="All_Disclaimer_Text-1"
            >
                click here.
            </span>
            &nbsp;If you are US based investor{' '}
            <span
                style={{color: '#1890ff', cursor: 'pointer'}}
                onClick={() => {
                    setUSInvestor(true);
                    setHKInvestor(false);
                }}
                data-testid="All_Disclaimer_Text-2"
            >
                click here.
            </span>
        </>
    );

    const Middle_Text_HK = () => (
        <div>
            By clicking Accept you agree to be bound by the following
            disclaimer, the{' '}
            <a
                // href="https://researchwise.dbsvresearch.com/Researchmanager/DownloadResearch.aspx?E=fhddfkQEByd191c2VyaWRAQA=="
                href={`https://www.dbs.com/insightsdirect/disclaimer?type=equity`}
                target="_blank"
                // style={{textDecoration: 'underline'}}
                // target="_self"
                rel="noopener noreferrer"
            >
                General Disclosure/Disclaimer,
            </a>{' '}
            the company-specific disclaimer, the{' '}
            <a
                // href="https://researchwise.dbsvresearch.com/Researchmanager/DownloadResearch.aspx?E=fhddfkQEByd191c2VyaWRAQA=="
                href={`https://www.dbs.com/terms/default.page`}
                target="_blank"
                // target="_self"
                rel="noopener noreferrer"
                // style={{textDecoration: 'underline'}}
                // style={{marginLeft: "10px"}}
            >
                Electronic T&Cs
            </a>{' '}
            <a
                // href="https://researchwise.dbsvresearch.com/Researchmanager/DownloadResearch.aspx?E=fhddfkQEByd191c2VyaWRAQA=="
                href={`https://www.dbs.com/privacy/default.page`}
                target="_blank"
                // target="_self"
                rel="noopener noreferrer"
                // style={{textDecoration: 'underline'}}
                // style={{marginLeft: "10px"}}
            >
                DBS Privacy Policy
            </a>{' '}
            of DBS Bank Ltd., its related corporations, affiliates and branches
            (collectively “DBS Group”) as well as the DBS Data Policy of DBS
            Bank (Hong Kong) Limited for the use of Insights Direct.
        </div>
    );

    const All_Text = () => (
        <div>
            By clicking Accept you agree to be bound by the following
            disclaimer, the{' '}
            <a
                // href="https://researchwise.dbsvresearch.com/Researchmanager/DownloadResearch.aspx?E=fhddfkQEByd191c2VyaWRAQA=="
                href={`https://www.dbs.com/terms/default.page`}
                target="_blank"
                style={{textDecoration: 'underline'}}
                // target="_self"
                rel="noopener noreferrer"
            >
                Electronic T&Cs
            </a>{' '}
            and{' '}
            <a
                // href="https://researchwise.dbsvresearch.com/Researchmanager/DownloadResearch.aspx?E=fhddfkQEByd191c2VyaWRAQA=="
                href={`https://www.dbs.com/privacy/default.page`}
                target="_blank"
                // target="_self"
                rel="noopener noreferrer"
                style={{textDecoration: 'underline'}}
                // style={{marginLeft: "10px"}}
            >
                DBS Privacy Policy
            </a>{' '}
            for the use of Insights Direct. You have also consented to receiving
            the DBS Vicker's Daily Newsletter.
        </div>
    );
    return (
        <Modal
            centered={window.innerWidth > 1024 ? true : false}
            title={
                <div>
                    <img
                        src={SmallLogo}
                        style={{marginRight: 15, width: 35}}
                        alt="logo"
                    />
                    {terms === '0' ? 'Terms' : 'DBS Research Disclaimer'}
                </div>
            }
            visible={activeModal === MODALS.DISCLAIMER}
            closable={false}
            onCancel={() => onDecline()}
            destroyOnClose
            cancelText="Decline"
            okText="Accept"
            onOk={() => onAccept()}
            wrapClassName="terms-modal"
            okButtonProps={{loading}}
            maskStyle={{
                backdropFilter: 'blur(6px)',
                background: '#fff0',
            }}
            className="disclaimer-modal"
            data-testid="disclaimer-modal-1"
        >
            {/* {hkTermAccepted !== '1' ? null : null} */}
            {isHKInvestor
                ? // storage.fetch.userDetails()?.country === 'Hong Kong'
                  // &&
                  // !isUSInvestor
                  HK_Disclaimer_Text()
                : isUSInvestor
                ? US_Disclaimer_Text()
                : All_Disclaimer_Text()}
            {/* This disclaimer is only for {isUSInvestor ? 'US' : 'non-US'}{' '}
            investors. &nbsp;If you are a {isUSInvestor ? 'non-US' : 'US'}{' '}
            investor{' '} */}
            {/* <span
                style={{color: '#1890ff', cursor: 'pointer'}}
                onClick={() => setUSInvestor(!isUSInvestor)}
            >
                click here.
            </span> */}
            <br />
            <br />
            {isHKInvestor ? Middle_Text_HK() : All_Text()}
            <br />
            {/* <br/> */}
            {/* <div>
                You have also consented to receiving the DBS Vicker's Daily
                Newsletter.
            </div> */}
            {isUSInvestor ? US_terms() : non_US_terms()}
            {/* <div className="terms">
              <a
                // href="https://researchwise.dbsvresearch.com/Researchmanager/DownloadResearch.aspx?E=fhddfkQEByd191c2VyaWRAQA=="
                href={`https://www.dbs.com/terms/default.page`}
                target="_blank"
                // target="_self"
                rel="noopener noreferrer"
              >
                Electronic T&Cs
              </a>
              <a
                // href="https://researchwise.dbsvresearch.com/Researchmanager/DownloadResearch.aspx?E=fhddfkQEByd191c2VyaWRAQA=="
                href={`https://www.dbs.com/privacy/default.page`}
                target="_blank"
                // target="_self"
                rel="noopener noreferrer"
                style={{marginLeft: "10px"}}
              >
                DBS Privacy Policy
              </a>
            </div> */}
        </Modal>
    );
};
export default DisclaimerModal;
